import cacheLs from "../cacheLs"

export default {
  addIntrest (state, data) {
    state.selectedintrest = { ...data }
    cacheLs.set_intrest(data)
  }
}
